import * as React from "react";
import {AppTranslations} from "../../../../components/Utils/translations/AppTranslations";
import {ConfirmationDialogInfo} from "../builder/models";

import "./ConfirmationDialog.scss";
import {VeBoxModal} from "../../../../components/modal/VeBoxModal";

declare var AppTranslations: AppTranslations;

export interface ConfirmationDialogProps {
    confirmationDialogInfo: ConfirmationDialogInfo;
    onConfirm: (options: any) => void;
    onCancel: () => void;
}

export interface ConfirmationDialogState {
    options: any;
    reasonValue: any;
}

function capitalize(str): string {
    if (!str || str.length === 0) {
        return str;
    }
    return str[0].toUpperCase() + str.slice(1);
}

export class ConfirmationDialog extends React.Component<ConfirmationDialogProps, ConfirmationDialogState> {

    constructor(props) {
        super(props);
        this.state = {
            options: {},
            reasonValue: "",
        };
    }

    private onDialogConfirmed = () => {
        if (this.props.onConfirm) {
            this.props.onConfirm(this.state.options);
        }
    }

    private onOptionChanged = (key, value) => (e) => {
        this.setState({
            options: {
                ...this.state.options,
                [key]: this.state.options[key] === undefined ? value : undefined,
            },
        });
    }

    private onReasonChange = (e) => {
        this.setState({
            reasonValue: e.target.value,
            options: {
                ...this.state.options,
                reasonGuid: e.target.value || null,
            },
        });
    }


    public render() {
        const reasons = this.props.confirmationDialogInfo.reasons || [];

        const hasReason: boolean = reasons.length > 0;

        return (
            <VeBoxModal style={{width: 350}}>
                <VeBoxModal.Header title={this.props.confirmationDialogInfo.title}/>
                <VeBoxModal.Section>
                    <p>{this.props.confirmationDialogInfo.description}</p>
                    {hasReason ?
                        <div className={"reasons"} onChange={this.onReasonChange}>
                            <div className={"reason-field capitalize"}>
                                <p className={"capitalize margin-bottom-10"}>
                                    {AppTranslations.equipmentSettingsPage.confirmationDialogReasonLabel}
                                </p>
                                <select
                                    className={"outlined-select width-100p capitalize"}
                                    onChange={this.onReasonChange}
                                    value={this.state.reasonValue}
                                >
                                    <option value={""} className={"capitalize"}>
                                        -- {AppTranslations.genericWords.select} --
                                    </option>
                                    {reasons.map((x, i) => {
                                        return (
                                            <option
                                                key={i}
                                                value={x.paramValue}
                                                className={"capitalize"}
                                            >
                                                {capitalize(x.paramName)}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                        : null}
                    {this.props.confirmationDialogInfo.question
                        ? <p> {this.props.confirmationDialogInfo.question} </p>
                        : null
                    }
                    {!jQuery.isEmptyObject(this.props.confirmationDialogInfo.options)
                        ? <div className={"ConfirmationDialog-additional-options"}>
                            {Object.keys(this.props.confirmationDialogInfo.options).map((key, index) => {
                                const optionKey = this.props.confirmationDialogInfo.options[key].paramName;
                                return (
                                    <div className={"confirmation-options"} key={key}>
                                        <input
                                            name={"option_" + index}
                                            type={"checkbox"}
                                            style={{marginRight: "5px"}}
                                            checked={this.state.options[optionKey] !== undefined}
                                            onChange={this.onOptionChanged(
                                                this.props.confirmationDialogInfo.options[key].paramName,
                                                this.props.confirmationDialogInfo.options[key].paramValue,
                                            )}
                                        />
                                        <label htmlFor={"option_" + index}>
                                            {this.props.confirmationDialogInfo.options[key].description}
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                        : null}
                </VeBoxModal.Section>
                <VeBoxModal.StandardActions
                    canSubmit={!(hasReason && this.state.reasonValue === "")}
                    onSubmit={this.onDialogConfirmed}
                    onCancel={this.props.onCancel}
                />
            </VeBoxModal>
        );
    }
}
